
function stringCompare(a, b) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
        : a === b;
}

module.exports = {
    traceLog(message, caller){
        const environment = ['production', 'preprod', 'int']
        if(!environment.includes(process.env.NODE_ENV)){
            console.log(`[${new Date().toISOString()}] ${caller || ""} : ${message}`);
        }
    },
};



// WEBPACK FOOTER //
// ./src/logging.js